<!-- 景区管理-积分抵扣 -->

<template>
  <div class="points-deduc-container main-cnt">
    <div class="content">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="left-content">
            <div class="deduct-title">当前景区</div>
            <div class="m-m-t store-list">
              <div v-if="sourceLists.length == 0" class="no-data">暂无数据</div>
              <div v-for="(item, i) in sourceLists" :key="i" v-else>
                <div class="store-title" :class="activeIndex == i ? 'activeStyle' : ''" @click="onClickStore(i)">
                  {{ item.s_name }}</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="middle-content">
            <div class="deduct-title">会员账号</div>
            <div class="m-m-t">
              <el-autocomplete v-model.trim="searchMembers" value-key="smr_name" :fetch-suggestions="querySearch"
                placeholder="请输入会员账" @select="handleSelect" clearable>
                <template #default="{ item }">
                  <div class="flex">
                    <div style="margin-right: 15px;">{{ item.m_realname }}</div>
                    <div>{{ item.m_mobile }}</div>
                  </div>
                </template>
              </el-autocomplete>
            </div>
            <div class="l-m-t" v-if="memberInfo.m_id">
              <div class="deduct-title">会员信息</div>
              <div class="m-m-t member-info">
                <div class="flex">
                  <div class="members-title flex-shrink">会员姓名：</div>
                  <div class="text-hidden">{{ memberInfo.m_realname }}</div>
                </div>
                <div class="flex s-m-t">
                  <div class="members-title flex-shrink">会员性别：</div>
                  <div class="text-hidden">{{ memberInfo.m_sex == '1' ? '男' : memberInfo.m_sex == '2' ? '女' : '未知' }}
                  </div>
                </div>
                <div class="flex s-m-t">
                  <div class="members-title flex-shrink">会员生日：</div>
                  <div class="text-hidden">{{ memberInfo.m_birth }}</div>
                </div>
                <div class="flex s-m-t">
                  <div class="members-title flex-shrink">会员账号：</div>
                  <div class="text-hidden">{{ memberInfo.m_mobile }}</div>
                </div>
                <div class="flex s-m-t">
                  <div class="members-title flex-shrink">会员等级：</div>
                  <div class="text-hidden">{{ memberInfo.m_level_label }}</div>
                </div>
                <div class="flex s-m-t">
                  <div class="members-title flex-shrink">是否业主：</div>
                  <div class="text-hidden">{{ memberInfo.m_owner == '1' ? '是' : '否' }}</div>
                </div>
              </div>
              <div class="s-m-t points">
                <img src="@/assets/img/points.png" />
                <div class="points-content">
                  <div class="points-num">{{ memberInfo.m_integration ? memberInfo.m_integration : 0 }}</div>
                  <div class="available-points">可用积分</div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="right-content">
            <div class="deduct-title">抵扣积分</div>
            <div class="m-m-t">
              <el-input v-model="integration_num" type="number" placeholder="请输入本次结账使用积分"
                oninput="if(value<0)value=0" />
            </div>

            <div class="deduct-title l-m-t">订单编号</div>
            <div class="m-m-t">
              <el-input v-model="other_sn" placeholder="请输入本次结账订单编号" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="foot-operate">
      <el-button class="confirm-btn" :loading="isLoading" :disabled="isLoading"
        @click="onConfirmVerifica">确认核销</el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, } from "vue";
import { ScenicApi, BasicApi, } from "@/plugins/api.js";
import { ElMessage, } from "element-plus";
import { useStore } from "vuex";

// 权限
const store = useStore();
const menuTokens = computed(() => store.state.menuToken.menuTokens);
const authData = ref([]);
watch(
  () => menuTokens.value,
  (data) => {
    if (data.length) {
      authData.value = data;
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const activeIndex = ref(0);  // 选择景区下标
const sourceLists = ref([]);  // 景区数据
const searchMembers = ref('');  // 搜索会员
const isLoading = ref(false);  // 按钮加载状态
const integration_num = ref('');  // 抵扣积分
const other_sn = ref('');  // 订单编号
const memberInfo = ref(''); // 选择会员信息
/**
 * 
 * 点击景区
 * 
 * **/
const onClickStore = (i) => {
  activeIndex.value = i;
}
/**
 * 
 * 获取景区
 * 
 * **/
const getAllSunData = () => {
  BasicApi.getAllScenicData({ is_verify: '1', }).then((res) => {
    if (res.Code === 200) {
      sourceLists.value = res.Data ? res.Data : [];
    } else {
      ElMessage.error(res.Message);
    }
  });
}
/**
*
* 搜索会员
*
* */
const querySearch = (queryString, cb) => {
  if (!queryString) {
    cb([]);
    return false;
  }
  BasicApi.searchMembers({ keyword: queryString, }).then((res) => {
    if (res.Code === 200) {
      cb(res.Data.list);
    } else {
      ElMessage.error(res.Message);
    }
  });
};
/**
*
* 选择会员
*
* */
const handleSelect = (item) => {
  memberInfo.value = item;
}
/**
 * 
 * 确认核销
 * 
 * **/
const onConfirmVerifica = () => {
  if(sourceLists.value.length == 0) {
    ElMessage.error('请选择景区！');
    return false;
  }
  if (!memberInfo.value.m_id) {
    ElMessage.error('请选择会员账户！');
    return false;
  }
  if (!integration_num.value) {
    ElMessage.error('请输入本次结账使用积分！');
    return false;
  }
  isLoading.value = true;
  let params = {
    source_id: sourceLists.value[activeIndex.value].s_id,
    m_id: memberInfo.value.m_id,
    integration_num: integration_num.value,
    other_sn: other_sn.value,
  };
  ScenicApi.scenicIntegralUsed(params).then((res) => {
    if (res.Code === 200) {
      activeIndex.value = 0;
      memberInfo.value = '';
      integration_num.value = '';
      other_sn.value = '';
      ElMessage.success("积分核销成功！");
      isLoading.value = false;
    } else {
      ElMessage.error(res.Message);
      isLoading.value = false;
    }
  });
}

onMounted(() => {
  getAllSunData();
});

</script>
<style lang="scss">
.points-deduc-container {
  font-family: "Source Han Sans CN";

  .content {
    border-bottom: 1px solid #eeeff2;

    .el-input__inner {
      height: 48px;
    }

    .el-autocomplete {
      width: 100%;
    }

    .no-data {
      text-align: center;
      margin-top: 15px;
      color: #92979E;
    }
  }

  .store-list {
    overflow: auto;
    height: calc(100vh - 275px);
  }

  .left-content {
    border-right: 1px solid #eeeff2;
    height: calc(100vh - 210px);
    padding: 15px;
  }

  .middle-content {
    border-right: 1px solid #eeeff2;
    height: calc(100vh - 210px);
    padding: 15px 15px 10px 0;
  }

  .right-content {
    padding: 15px 15px 10px 0;
  }

  .deduct-title {
    font-size: 16px;
    color: #262C30;
    font-weight: bold;
  }

  .store-title {
    height: 48px;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
  }

  .activeStyle {
    background-color: var(--theme-color);
    color: #FFFFFF;
    border-radius: 4px;
  }

  .member-info {
    font-size: 14px;
  }

  .members-title {
    color: #92979E;
    width: 90px;
  }

  .foot-operate {
    text-align: end;
    margin-top: 15px;
    margin-right: 15px;
  }

  .confirm-btn {
    width: 120px;
    padding: 0;
    color: #fff;
  }

  .points {
    position: absolute;
  }

  .points-content {
    position: absolute;
    top: 25px;
    left: 80px;
  }

  .points-num {
    font-size: 30px;
    color: #FFFFFF;
  }

  .available-points {
    font-size: 14px;
    color: #FFFFFF;
    margin-top: 5px;
  }
}
</style>